import Icon from 'veui/components/Icon'

Icon.register({
  star: {
    paths: [
      {
        d: 'M588.7 726.67a32 32 0 01-14.76-3.61L384 624.36l-189.94 98.7a32 32 0 01-46.32-33.65l35.17-211.15L30.34 328.11A32 32 0 0148 273.66l211.68-31.8 95.69-191.49a32 32 0 0157.26 0l95.65 191.49L720 273.66a32 32 0 0117.7 54.45L585.09 478.26l35.17 211.15a32 32 0 01-31.56 37.26zM384 556.3c5.14 0 10.2 1.24 14.75 3.61l147.86 76.82-27.38-164.36a32 32 0 019.12-28.06l118.76-116.88-164.78-24.75a32 32 0 01-23.87-17.34L384 136.28l-74.46 149.06a32 32 0 01-23.87 17.34l-164.78 24.75 118.76 116.88a32 32 0 019.12 28.06l-27.38 164.36 147.86-76.82A31.89 31.89 0 01384 556.3z'
      }
    ],
    width: '768',
    height: '768'
  }
})
